module.exports = __webpack_public_path__ + "03d6232b274a2b0189930a2534df73d2.png";